export default "__VITE_ASSET__D0IlK8wc__"